<template>
	<div
		v-if="loading"
		class="loading-spinner-container"
	>
		<LoadingSpinner :is-overlay="true" />
	</div>
	<div v-else>
		<div class="journeys-skew-banner">
			<div class="container">
				<div class="row">
					<div class="col journeys-skew-banner__content text-center">
						<h1 class="h2">{{ microcopy?.heading }}</h1>
						<p>{{ microcopy?.summary }}</p>
					</div>
				</div>
			</div>
		</div>
		<div class="container pull-up">
			<form
				class="w-100"
				@submit.prevent
			>
				<div class="rounded-container rounded-container--single-item rounded-container--narrow">
					<div class="row">
						<div class="col">
							<ClickableDropdownComponent
								:advisers="financialAdvisers"
								@selected-adviser="(payload) => {
									this.selectedAdviser = payload
								}"
							/>
							<p
								class="error-text"
								v-if="lookupError"
							>{{ lookupError }}</p>
						</div>
					</div>
				</div>
				<div class="row btm-btn-group m-auto mb-5">
					<div class="col text-center d-flex flex-column align-items-center">
						<GenericButton
							:label-text="microcopy?.nextButtonLabel"
							:button-disabled="!isValid"
							button-type="button"
							@button-click="handleClick"
						/>
						<BackButton
							:back-text="microcopy.backButtonLabel"
							@back-click="handleBackButton"
							style="margin-top: 32px;"
						/>
					</div>
				</div>
			</form>

		</div>
	</div>
</template>
<script>
import TextInputField from '@/shared/components/TextInputField.vue';
import GenericButton from '@/shared/components/GenericButton.vue';
import BackButton from '@/shared/components/BackButton.vue';
import ClickableDropdownComponent from '@/shared/components/ClickableDropdownComponent.vue';
import LoadingSpinner from '@/shared/components/LoadingSpinner.vue';

import router from '../router/index.js';

import { mapStores, mapActions } from 'pinia';
import { useAppointmentReferralStore } from '../stores/appointmentReferralStore.js';

export default {
	components: {
		TextInputField,
		GenericButton,
		BackButton,
		ClickableDropdownComponent,
		LoadingSpinner
	},
	data() {
		return {
			inputValue: '',
			lookupError: false,
			microcopy: '',
			selectedAdviser: '',
			financialAdvisers: [],
			loading: false
		};
	},
	computed: {
		...mapStores(useAppointmentReferralStore),
		isValid() {
			return this.selectedAdviser !== ''
		}
	},
	methods: {
		...mapActions(useAppointmentReferralStore, ['postSelectedAdviser']),
		handleClick() {
			this.putFinancialAdviser();
		},
		handleBackButton() {
			router.back();
		},
		getAllAdvisers() {
			this.loading = true;
			fetch('/sapi/FinancialConsultants', {
				method: 'GET',
				headers: {
					'Accept': 'application/json'
				}
			})
				.then(response => {
					if (!response.ok) {
						throw new Error(`HTTP error, status: ${response.status}`);
					}
					return response.json();
				})
				.then(data => {
					this.loading = false;
					this.financialAdvisers = data;
				})
				.catch(error => {
					this.loading = false;
					console.error('Fetch error:', error);
				});
		},
		putFinancialAdviser() {
			this.loading = true;

			const myHeaders = new Headers();
			myHeaders.append("Content-Type", "application/json");

			// Customer type 1 for new customers
			const raw = JSON.stringify({
				'selectedId': this.selectedAdviser?.wesAdviserNumberCdsKey,
				'customerType': 1
			});

			appInsights.trackTrace({
				message: '[BAARefJourney] API select adviser - Started',
				properties: { area: 'appointment-referral-journey', hostname: location.hostname },
				severityLevel: 1
			});

			const options = {
				method: "PUT",
				headers: myHeaders,
				body: raw,
				redirect: "follow"
			};

			fetch('/sapi/FinancialConsultants/select/', options)
				.then((res) => {
					if (!res.ok) {
						console.error(`Request failed with status ${res.status}`);
						appInsights.trackTrace({
							message: `[BAARefJourney] API select adviser - Failed - received HTTP ${res.status}`,
							properties: { area: 'appointment-referral-journey', hostname: location.hostname },
							severityLevel: 4
						});

						this.lookupError = true;
						return;
					}

					if (res.status === 204) { // unsure if 204 gets sent back on this one
						appInsights.trackTrace({
							message: '[BAARefJourney] API select adviser - Succeeded - received HTTP 204',
							properties: { area: 'appointment-referral-journey', hostname: location.hostname },
							severityLevel: 1
						});

						this.lookupError = true;
						return;
					}

					appInsights.trackTrace({
						message: '[BAARefJourney] API select adviser - Succeeded',
						properties: { area: 'appointment-referral-journey', hostname: location.hostname },
						severityLevel: 1
					});

					this.lookupError = false;

					this.postSelectedAdviser(this.selectedAdviser);
					return router.push('your-financial-adviser');
				})
				.catch((e) => {
					console.error(e);
					appInsights.trackException({
						exception: e,
						properties: { area: 'appointment-referral-journey' },
						severityLevel: 4
					});

					this.lookupError = true;
				})
				.finally(() => {
					this.loading = false;
				});
		},
	},
	mounted() {
		this.microcopy = window.bookAnAppointmentReferralMicrocopy?.fcName;
		document.title = this.microcopy?.metaTitle
		this.getAllAdvisers();

	}
};
</script>
